import React, { useState } from 'react';
import adData from '../data/feedad.json';

const FeedAd = () => {
  const { description, asset, screenshot } = adData;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2 style={{ marginBottom: '0.5rem' }}>Rimo3 Clarity Feed Ad Preview</h2>
      <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1.5rem', maxWidth: '900px' }}>
        {description}
      </p>

      {/* Ad Preview */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '1920px',
          margin: '0 auto',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          cursor: 'pointer',
        }}
        onClick={() => setModalOpen(true)}
      >
        <img
          src={asset.image}
          alt={`${asset.title} — Banner`}
          style={{ width: '100%', display: 'block' }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: '#fff',
          }}
        >
          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>{asset.title}</h1>
          <p style={{ fontSize: '1.2rem', marginBottom: '1.25rem' }}>{asset.subtitle}</p>
          <a
            href={asset.ctaUrl}
            target="_blank"
            rel="noreferrer"
            style={{
              backgroundColor: '#fff',
              color: '#000',
              padding: '0.65rem 1.5rem',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            }}
          >
            {asset.ctaText}
          </a>
        </div>
      </div>

      {/* Asset Details */}
      <div style={{ marginTop: '1rem', color: '#666', fontSize: '0.9rem' }}>
        Asset Size: {asset.width} × {asset.height}px
      </div>

      {/* Screenshot of placement */}
      <div style={{ marginBottom: '2rem' }}>
        <h4 style={{ marginBottom: '0.5rem' }}>Screenshot of Ad Placement on The Feed</h4>
        <img
          src={screenshot}
          alt="Feed placement preview"
          style={{ maxWidth: '100%', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
        />
      </div>

      {/* Modal */}
      {modalOpen && (
        <div
          onClick={() => setModalOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 3000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              backgroundColor: '#000',
              padding: '1rem',
              borderRadius: '8px',
              maxWidth: '90vw',
              maxHeight: '90vh',
            }}
          >
            <button
              onClick={() => setModalOpen(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                fontSize: '2rem',
                background: 'transparent',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <img
              src={asset.image}
              alt="Ad Full Preview"
              style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '6px' }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedAd;